module.exports = __webpack_public_path__ + "img/header.ac37202c.jpg";